export default __webpack_public_path__ + "static/media/london-drugs.63398436.png";